import { Tab, Tabs } from '@material-ui/core';
import type { ChangeEvent, FC } from 'react';
import { ProductConfig, ProductType } from '../../types';
import TicketIcon from '@material-ui/icons/AirplanemodeActiveOutlined';
import HotelIcon from '@material-ui/icons/HotelOutlined';
import InsuranceIcon from '@material-ui/icons/ReceiptOutlined';
import TransferIcon from '@material-ui/icons/LocalTaxiOutlined';
import ExtraIcon from '@material-ui/icons/ExtensionOutlined';

interface Props {
  value: ProductType | undefined;
  setValue: (value: ProductType) => void;
  availableProducts?: ProductType[];
}

const ProductTabs: FC<Props> = ({ value, setValue, availableProducts }) => {
  const products: Array<ProductConfig> = [
    { name: 'Hotel', id: 'hotel', icon: <HotelIcon /> },
    { name: 'Ticket', id: 'ticket', icon: <TicketIcon /> },
    { name: 'Transfer', id: 'transfer', icon: <TransferIcon /> },
    { name: 'Insurance', id: 'insurance', icon: <InsuranceIcon /> },
    { name: 'Extra', id: 'extra', icon: <ExtraIcon /> }
  ];

  const productTabs = availableProducts ? products.filter((product) => availableProducts.includes(product.id)) : products;

  const handleChange = (event: ChangeEvent<{}>, newValue: ProductType) => {
    setValue(newValue);
  };

  return (
    <Tabs variant="scrollable" value={value} scrollButtons="auto" onChange={handleChange} aria-label="icon label tabs example">
      {productTabs.map((product) => (
        <Tab
          key={product.id}
          style={{ fontSize: '12px', minWidth: '75px' }}
          icon={product.icon}
          label={product.name}
          value={product.id}
        />
      ))}
    </Tabs>
  );
};

export default ProductTabs;
